<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <h1 class="docs__title">Privacy Policy</h1>
        <div class="docs__block">
          <h6>1. Information We Collect</h6>
          <p>LUNATRIX LTD specializes in developing digital solutions including website creation, design, and software consulting services.</p>
          <ul>
            <li>Contact details (first name, last name, email, phone number)</li>
            <li>Professional information (company name)</li>
            <li>Technical data (device specifications, operating system, network information)</li>
            <li>Usage data (IP addresses, search queries, cookie data)</li>
          </ul>
          <p>This information may be provided voluntarily by users or collected automatically through website interactions. We use cookies to improve website performance, enable features, and deliver customized content. Your data remains confidential and will not be disclosed to unaffiliated third parties except when legally required.</p>
          <p>Providing optional information is always at your discretion and will not limit your access to our services.</p>
        </div>
        <div class="docs__block">
          <h6>2. How We Use Your Information</h6>
          <p>We process your personal data to:</p>
          <ul>
            <li>Deliver and improve our services</li>
            <li>Respond to customer inquiries and provide support</li>
            <li>Protect our services from security threats and fraudulent activity</li>
            <li>Analyze usage patterns to enhance user experience</li>
            <li>Develop better products and evaluate marketing effectiveness</li>
          </ul>
        </div>
        <div class="docs__block">
          <h6>3. Legal Basis for Data Processing</h6>
          <p>We handle your information for these specific purposes:</p>
          <ul>
            <li>Website operation and service delivery</li>
            <li>Security protection and unauthorized access prevention</li>
            <li>Customer service and inquiry resolution</li>
            <li>Usage analytics and traffic monitoring</li>
            <li>Convenience features for returning visitors</li>
            <li>Internal business operations</li>
          </ul>
          <p>Should our data processing purposes change, we will obtain your consent before proceeding.</p>
        </div>
        <div class="docs__block">
          <h6>4. Information Sharing Policy</h6>
          <p>We maintain strict confidentiality of your personal data and will not share it with third parties without your explicit permission. </p>
          <p>Exceptions may include:</p>
          <ul>
            <li>Service provision requirements</li>
            <li>Legal compliance obligations</li>
            <li>Security threat prevention</li>
            <li>Suspected illegal activity investigations</li>
          </ul>
          <p>Please note that while we implement security measures, other entities (such as network providers) may monitor online activities.</p>
        </div>
        <div class="docs__block">
          <h6>5. Contact Information</h6>
          <p>For questions regarding this privacy policy, please contact us at: <a href="mailto:info@lunatrixltd.com">info@lunatrixltd.com</a></p>
        </div>
        <div class="docs__block">
          <p>This version improves readability while maintaining all legal disclosures. The content is organized into clear sections with bullet points for better comprehension. Legal terminology has been simplified where possible without losing meaning or compliance requirements.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.docs {
  padding-block: 80px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__title {
    color: #272343;
    font-size: 48px;
    font-weight: 900;
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & h6 {
    color: #272343;
    font-size: 24px;
    font-weight: 900;
  }

  & p {
    color: #636270;
    font-size: 20px;
    font-weight: 400;
  }

  & li {
    color: #636270;
    font-size: 20px;
    font-weight: 400;
  }

  & a {
    color: #272343;
    font-size: 20px;
    font-weight: 600;

    @include hover {
      color: #19172c;
    }
  }
}

ul {
  padding-left: 30px;
}

@media (max-width: 650px) {
  .docs {
    &__title {
      font-size: 32px;
    }

    & h6 {
      font-size: 18px;
    }

    & p {
      font-size: 14px;
    }

    & li {
      font-size: 14px;
    }

    & a {
      font-size: 14px;
    }
  }
}
</style>